export interface BadgeProps {
  text: string;
  type?: IBadgeType;
}

export enum IBadgeType {
  "success" = "success",
  "error" = "error",
  "warning" = "warning",
  "info" = "info",
  "analysis" = "analysis",
  "muted" = "muted",
  "draft" = "draft"
}
